
<template>
  <div class="home">
    {{ platName }}
    <div class="scrllCss">
      <div class="calendar">
        <el-calendar v-model="calendarValue[0]">
          <template slot="dateCell" slot-scope="{date, data}">
            <div
              :class="(calendarList[data.day]||{})['has_cost']==0?'is-nodata':''"
              v-matomo="{behaviorCategory: `竞代数据管理(${platName})`,  name: '竟代数据编辑' }"
              class="dayDay"
              @click="clickRl(data)"
            >
              <el-tooltip
                height="300"
                placement="top"
                :disabled="(((calendarList[data.day]||{})['account_list'])||[]).length==0"
              >
                <div slot="content" class="toptipsClass">
                  <div>
                    <div class="headTop">
                      <span class="names jd-names">竞代名称</span>
                      <span class="names">整体</span>
                      <span class="names">IAA</span>
                      <span class="names">IAP</span>
                      <span class="names">小游戏</span>
                    </div>
                    <div class="contentBot">
                      <div
                        v-for=" (item ,index ) in  ((calendarList[data.day]||{})['account_list'])"
                        :key="index"
                      >
                        <span class="topitems jd-topitems">{{item.plat_username}}</span>
                        <span class="topitems">{{item.cost?item.cost:'--'}}</span>
                        <span class="topitems">{{item.iaa_cost?item.iaa_cost:'--'}}</span>
                        <span class="topitems">{{item.iap_cost ? item.iap_cost :'--'}}</span>
                        <span class="topitems">{{item.game_cost ?item.game_cost :'--'}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <ul
                    v-for=" (item ,index ) in  ((calendarList[data.day]||{})['account_list'])"
                    :key="index"
                  >
                    <li>
                      
                    </li>
                    <li>
                      <span class="tooltipSpan">{{item.plat_username}}：{{item.cost}}</span>
                      <span>在这显示区域</span>
                    </li>
                  </ul>-->
                </div>
                <div>
                  <div class="dayTop">
                    <span class="dayEvery">{{nowDate(data.day)}}日</span>
                    <span
                      :class="((calendarList[data.day]||{})['holiday_cn'])? 'isHoliday' : ''"
                    >{{(calendarList[data.day]||{})['holiday_cn']}}</span>
                  </div>

                  <div
                    class="dayBot"
                    v-if=" (((calendarList[data.day]||{})['account_list'])||[]).length>2"
                  >
                    <ul
                      v-for=" (item ,index ) in  ((calendarList[data.day]||{})['account_list'].slice(0,2))"
                      :key="index"
                    >
                      <li>
                        <span class="titleSpan">{{item.plat_username}}</span>

                        <span class="spanR">{{item.cost}}</span>
                      </li>
                    </ul>
                    <p class="pdian titleSpan">...</p>
                  </div>
                  <div class="dayBot" v-else>
                    <ul
                      v-for=" (item ,index ) in  ((calendarList[data.day]||{})['account_list'])"
                      :key="index"
                    >
                      <li>
                        <span class="titleSpan">{{item.plat_username}}</span>

                        <span class="spanR">{{item.cost}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-calendar>
      </div>
    </div>

    <CONSUME
      ref="consumeRef"
      :pageFuncNames="pageFuncNames"
      :rldata="rldata"
      :dataDay="dataDay"
      :platId="platId"
      @upDataList="funcBackApi"
    ></CONSUME>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import API from "@/api/competeManage.js";
import CONSUME from "./consumeDialog";

export default {
  name: "Calendar",
  components: {
    CONSUME
  },
  props: {
    pageFuncNames: {
      type: Array,
      default: () => {
        return [];
      }
    },
    platId: {
      type: String,
      default: ""
    },
    calendarValue: {
      type: Array,
      default: () => {
        return [];
      }
    },
    calendarList: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    monthDate: {
      type: Array,
      default: () => []
    },
    platName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [
      ],
      rldata: {
        //  isSelected: true, type: 'current-month', day: '2022-09-03'
      },
      dataDay: {}
    };
  },

  computed: {
    ...mapGetters(["name"])
  },
  watch: {
    calendarValue(val) {}
  },
  created() {},
  mounted() {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "every-row";
    },
    // 日历的日期值，01舍弃0返回1 ，其他正常返回
    nowDate(day) {
      let a = day
        .split("-")
        .slice(2)
        .join("")
        .slice(0, 1);
      let b = day
        .split("-")
        .slice(2)
        .join("")
        .slice(1, 2);
      let c = day
        .split("-")
        .slice(2)
        .join("-");

      if (a == 0) {
        return b;
      } else {
        return c;
      }
    },

    funcBackApi(options) {
      console.log(options);
      this.$emit("upDataList", options, "刷新日历");
    },
    clickRl(data) {
      console.log("点击", data);

      if (!this.pageFuncNames.includes("edit_compete_plat_username_data")) {
        this.$message({
          message: "非常抱歉,您没有编辑竞代信息的权限！",
          type: "warning"
        });
        return;
      }
      this.rldata = data;
      this.dataDay = (this.calendarList && this.calendarList[data.day]) || {};
      if (this.dataDay) {
        let AccList = this.dataDay["account_list"] || [];
        let newLength = AccList && AccList.length > 0;
        if (newLength) {
          this.$refs.consumeRef.showDialog("弹窗吧");
        } else {
          this.$message({
            message: "没有可编辑的竞代哦！",
            type: "warning"
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.toptipsClass {
  width: 600px;
  color: #fff;
}
.toptipsClass .headTop {
  width: 100%;
  height: 30px;
  line-height: 30px;
}

.toptipsClass .headTop .names {
  display: inline-block;
  width: 115px;
  text-align: left;
  font-weight: bold;
  height: 26px;
  line-height: 26px;
    white-space: nowrap;
}
.jd-names,.jd-topitems{
    width: 140px!important;
}
.toptipsClass .contentBot {
  max-height: 100px;
  overflow-y: auto;
}


.toptipsClass .contentBot .topitems {
  display: inline-block;
  width: 114px;
  text-align: left;
   font-weight: bold;
  height:26px;
  line-height: 26px;
    white-space: nowrap;
}

/*定义整体的宽度*/
.toptipsClass .contentBot::-webkit-scrollbar {
  width: 3px;
}
/*定义滚动条轨道*/
.toptipsClass .contentBot::-webkit-scrollbar-track {
  border-radius: 5px;
}
/*定义滑块*/
.toptipsClass .contentBot::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(27, 140, 236, 0.5);
}


.home {
  background-color: #fefefe;
  min-height: calc(100vh - 84px);
  font-size: 12px;
}

.home-run {
  max-width: 450px;
}
.is-selected {
  // color: red;
  background-color: #ffecea;
}

.calendar-day {
  text-align: center;
  color: #202535;
  line-height: 30px;
  font-size: 12px;
}
.is-nodata {
  background-color: #ffecea;
}

.is-info {
  color: #909399;
  font-size: 10px;
  margin-top: 5px;
}
.is-warning {
  color: #e6a23c;
  font-size: 10px;
  margin-top: 5px;
}
.is-danger {
  color: #f56c6c;
  font-size: 10px;
  margin-top: 5px;
}
.pdian {
  font-size: 18px;
  line-height: 2px;
  font-weight: 500;
}

.dayBot .titleSpan {
  display: inline-block;
  height: 16px;
  line-height: 16px;
  width: 70px;
  text-align: left;
  margin-right: 10px;
  color: #7f7f7f;
  padding-left: 5px;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
  text-overflow: ellipsis;
}

.tooltipSpan {
  display: inline-block;
  min-width: 60px;
  text-align: right;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}

.spanR {
  display: inline-block;
  color: #7f7f7f;
  height: 16px;
  line-height: 16px;
  vertical-align: middle;
}

.dayDay {
  position: relative;
  height: 100%;
}
.dayEvery {
  display: inline-block;
  font-size: 18px;

  padding-left: 5px;
  padding-top: 5px;
}
.dayTop {
  height: 40px;
}

.dayDay .isHoliday {
  position: absolute;
  top: 0;
  right: 0;
  color: #452604;
  background-color: #fce1cb;
  display: inline-block;
  padding: 5px 8px;
  min-width: 30px;
  line-height: 26px;
}
</style>
<style  >
.home .el-calendar__header {
  display: none;
}

.home .scrllCss {
  overflow-x: auto;
}
.home .calendar {
  min-width: 1064px;
  max-width: 1680px;
}

.home .el-calendar-table {
  /* height: 700px; */
}
.home .el-calendar-table thead th:before {
  content: "周";
}

.home .el-calendar__body {
  padding: 12px 0 20px 0;
}
.home .el-calendar__body tbody .el-calendar-table__row .prev {
  pointer-events: none;
}
.home .el-calendar__body tbody .el-calendar-table__row .prev .dayDay {
  display: none;
}
.home .el-calendar__body tbody .el-calendar-table__row .next {
  pointer-events: none;
}
.home .el-calendar__body tbody .el-calendar-table__row .next .dayDay {
  display: none;
}

.el-calendar-table tr td:first-child {
  border-left: 1px solid #d7d7d7;
}
/* 更换边框颜色 */
.el-calendar-table tr:first-child td {
  border-top: 1px solid #d7d7d7;
}
.el-calendar-table td {
  border-bottom: 1px solid #d7d7d7;
  border-right: 1px solid #d7d7d7;
}
.home .el-calendar-table td.is-selected {
  background-color: #ffffff;
}

.home .el-calendar-table .el-calendar-day {
  height: 98px;
}
.home .el-calendar-table .el-calendar-day:hover {
  background-color: #d6f4ff;
}

.home .el-calendar-table td.is-nodata {
  background-color: #ffecea;
}
.home .el-calendar-table td.is-today {
  background-color: #d6f4ff !important;
}
.home .el-calendar-table td.is-today .is-nodata {
  background-color: #d6f4ff !important;
}
.home .calendar .el-calendar__title {
  color: red;
}
.home .calendar .el-button-group {
  display: none;
}
.home .el-calendar-table tbody tr:last-child {
  /* //每个月的日历显示五行 */
  display: none !important;
}

.home .el-calendar-table .el-calendar-day {
  padding: 0px;
}
</style>
